@if (epm.text$ | async; as text) {
  <div class="cookies relative flex items-center justify-between px-20">
    <div class="cookies-inner cursor-pointer">
      <span>{{ 't.we-use' | translate }}
        <span class="hyperlink-color-1" (click)="goToPolicy()">
          {{ 'link.cookies' | translate }}
        </span> <br>
      </span>
      <span [innerHTML]="text"></span>
    </div>
    <span class="pointer pointer-au cursor-pointer hyperlink-color-1" (click)="cookiesAccepted()">{{'btn.accept' | translate}}</span>
  </div>
}
